/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tutor_Rooterror_Title1Inputs */

const en_tutor_rooterror_title1 = /** @type {(inputs: Tutor_Rooterror_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

const fr_tutor_rooterror_title1 = /** @type {(inputs: Tutor_Rooterror_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Tutor_Rooterror_Title1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const tutor_rooterror_title1 = /** @type {((inputs?: Tutor_Rooterror_Title1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tutor_Rooterror_Title1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tutor_rooterror_title1(inputs)
	return fr_tutor_rooterror_title1(inputs)
});
export { tutor_rooterror_title1 as "tutor_rootError_title" }